import { Component } from '@angular/core';

@Component({
  selector: 'app-icon-reset',
  templateUrl: './icon-reset.component.svg',
  styleUrls: ['./icon-reset.component.css'],
})
export class IconResetComponent {}
